import React, { Fragment,Component } from 'react';
import logo from '../images/privacy_banner.png';

class privacy extends Component {
    render() {
        return (
            <Fragment>
                <div className='img-container'>
                  <img src={logo} alt="privacy"/>
                </div>
                <div className="body-container">
                    <br/>
                    <div className="CenteredTitle">Privacy Policy</div>
                    <br/>
                    <div className="text-center">
                    Our applications and websites collect no personal data.<br/>
                    We use advertising to help us “Keep the lights on”.<br/>
                    For more information on Google Ads and your data please visit their <a href="https://support.google.com/ads/answer/1634057?hl=en">website</a>.


                    </div>
                </div>
            </Fragment>
        )
    }
}

export default privacy



// WEBPACK FOOTER //
// ./src/components/layout/privacy.js